import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { isArray, size } from "lodash";
import Joi, { schema } from "joi-browser";
import SubForm from "../../components/PartnerManage/SubForm";
import {
    getBprmForm,
    loadBprmForm,
    getStateCountyCity,
    getDataTypeCodemanager,
    saveBprmForm,
    updateBprmForm,
    getUpdateStatus,
    allStateCountyCityReceived,
    getTaskFormSavedStatus,
    taskFormSaved,
    getAllButtonProcessIds,
    formUpdated,
    updateSummaryBprmForm,
    getSummaryFormUpdateStatus,
    getSavedFormDocSasUrls,
    formSaved
} from "../../app/store/bprmForm";
import { getApplication, loadApplication, getApplicationData } from "../../app/store/application";
import { workflowTaskDone, executeBprmFormRule, getExecuteRuleAppData, getTaskDoneStatus, taskDone } from "../store/WorkflowEngine";
import Label from "./BprmDynamicControls/Label";
import TextBox from "./BprmDynamicControls/TextBox";
import Dropdown from "./BprmDynamicControls/Dropdown";
import Date from "./BprmDynamicControls/Date";
import Button from "./BprmDynamicControls/Button";
import Multiline from "./BprmDynamicControls/Multiline";
import { getCurrentUser } from "../store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import Radio from "./BprmDynamicControls/Radio";
import FileUpload from "./BprmDynamicControls/FileUpload";
import geoService, { getAllCountries, getGeoCountyData, getGeoStateData, getStateList } from "../../services/geoService";
import CheckBox from "./BprmDynamicControls/CheckBox";
import { getTemplatePdf, printTemplatePdf, templatePdfReceived } from "../store/template";
import ViewFile from "./BprmDynamicControls/ViewFile";
import DecryptAppData from "../../components/DecryptAppData";
import { CircularProgress, Button as MUIButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { loadAllButtonAlertMessages } from "../store/layoutUI";
import config from "../../config.json";
import { formatPhoneNumber, getDropdownCodemanager } from "../../services/appService";
import useDocDownload from "../hooks/useDocDownload";
import { getDocuments } from "../store/documents";
import { Link } from "react-router-dom";
import { uploadFileToBlob } from "../../services/blobUploadService";

export default function WorkflowElement(props) {
    const { wfTask, handleNextTask, appSummary,
        viewType, codeVerified, updatedStateData,
        wfTaskType, saveBtnProcessStatus,
        setSaveBtnProcessStatus, workflowFormData,
        documentInfo, handleCloseButton, actionType,
        wfForm, rateObj, subFormObj } = props;

    const [stateSchema, setStateSchema] = useState({});
    const [stateData, setStateData] = useState({});
    const [stateErrors, setStateErrors] = useState({});
    const [encryptionDecryptions, setEncryptionDecryptions] = useState({});
    //const [wfForm, setWfForm] = useState("");
    const [documents, setDocuments] = useState([]);
    const [application, setApplication] = useState("");
    const [aWorkfinityAppEntity, setAworkfinityAppEntity] = useState("");
    const [aWorkfinityApp, setAworkfinityApp] = useState("");
    const [stateCountyCity, setStateCountyCity] = useState([]);
    const [subformDataType, setSubformDataType] = useState([]);
    const [ddTypeCodMngr, setDdTypeCodMngr] = useState([]);
    const [frmDDTypes, setFrmDDTypes] = useState([]);
    const [subformItemIndex, setSubformItemIndex] = useState(1);
    const [codeIsVerified, setCodeIsVerified] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [btnProcessStatus, setBtnProcessStatus] = useState(saveBtnProcessStatus);
    const [isTaskForm, setIsTaskForm] = useState(false);
    const [isCountryStateChanged, setIsCountryStateChanged] = useState(true);
    const [currentButtonType, setCurrentButtonType] = useState("");
    const [currentButtonMessage, setCurrentButtonMessage] = useState("");
    const [printBtnProccess, setPrintBtnProccess] = useState(false);
    const [decryptShowHide, setDecryptShowHide] = useState(false);
    const [isEncryptedForm, setIsEncryptedForm] = useState(false);
    const [currentInputField, setCurrentInputField] = useState("");

    //const bprmFormSelector = useSelector(getBprmForm);
    const applicationSelector = useSelector(getApplication);
    const ruleAppDataSelector = useSelector(getExecuteRuleAppData);
    const summaryFormUpdateStatusSelector = useSelector(getSummaryFormUpdateStatus)
    const taskFormSavedStatusSelector = useSelector(getTaskFormSavedStatus);
    const taskDoneStatusSelector = useSelector(getTaskDoneStatus);
    const templatePdfSelector = useSelector(getTemplatePdf);
    const documentsSelector = useSelector(getDocuments);
    const savedFormDocSasUrlsSelector = useSelector(getSavedFormDocSasUrls);

    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();
    const printBody = useRef(null);

    useEffect(() => {
        if (!saveBtnProcessStatus) {
            setBtnProcessStatus(false);
            if (setSaveBtnProcessStatus)
                setSaveBtnProcessStatus(null);
        }
    }, [saveBtnProcessStatus])

    useEffect(() => {
        if (wfTask?.ciid > 0 && !appSummary)
            dispatch(loadApplication(wfTask?.ciid));

        if (viewType) {
            setIsDisabled(true);
        }
        else {
            setIsDisabled(false);
        }
    }, [wfTask]);

    useEffect(() => {
        if (codeVerified) setCodeIsVerified(true);
    }, [codeVerified]);

    useEffect(() => {
        if (applicationSelector.length > 0) {
            const latestApp = applicationSelector[applicationSelector.length - 1];
            setApplication(latestApp);
            const obj = getApplicationData(latestApp.applicationData);
            if (obj?.aWorkfinityApp)
                setAworkfinityApp(obj.aWorkfinityApp);
            if (obj?.aWorkfinityAppEntity)
                setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);

            if (workflowFormData && obj?.data) {
                const newData = { ...obj.data, ...workflowFormData };
                if (rateObj?.candidateRate) {
                    newData["candidateonboardingform.Rate_hour_Paid_to_Candidate"] = rateObj.candidateRate.toString();
                }
                setStateData(newData);

            } else if (obj?.data) {
                if (rateObj?.candidateRate) {
                    obj.data["candidateonboardingform.Rate_hour_Paid_to_Candidate"] = rateObj.candidateRate.toString();
                }
                setStateData(obj.data);
            }

        } else {
            setAworkfinityApp("");
            setAworkfinityAppEntity("");
            setStateData({});
        }
    }, [applicationSelector]);

    useEffect(() => {
        if (wfForm) {
            loadStateCounty();
            if (currentInputField === "dropdown" || currentInputField === "")
                loadDDType();
        }
    }, [stateData]);


    useEffect(() => {
        if (wfForm && wfForm !== "") {
            if ((wfForm?.isEdit !== null && !wfForm?.isEdit && wfTaskType !== "viewForm")) { setIsDisabled(false); }
            if (wfTask?.taskDoneStatus === 4) { setIsDisabled(true); }

            if (wfTask?.wfPhase === "Approved" && wfTask?.formId === config.formIds.candidate.ReportingForm && wfTask?.taskDoneStatus === 4) { setIsDisabled(false) }

            setIsEncryptedForm(wfForm.isEncrypted);

            setBtnProcessStatus(false);
            setDocuments([]);
            setStateSchema({});
            loadButtonProcessIds();
        }
    }, [wfForm])

    const loadDDType = async () => {
        const ddResult = getDataTypeCodemanager(wfForm);
        if (ddResult.ddTypeCodMngr.length > 0) {
            const result = await Promise.all(ddResult.ddTypeCodMngr.map(async (code) => {

                const ddItems = await getDropdownCodemanager(code.dataType, code.attribute);

                let childId = "";
                if (code.childDataType)
                    childId = code.childDataType.toLowerCase();
                if (code.childAttribute)
                    childId += "." + code.childAttribute;

                const ddTypeObj = {
                    controlId: code.dataType.toLowerCase() + "." + code.attribute,
                    optionData: ddItems,
                    allOptionData: ddItems,
                    childControlId: childId
                };
                return ddTypeObj;
            }));

            let updResult = [...result];
            result.map(dd => {
                if (dd.childControlId) {
                    const childObj = updResult.filter(x => x.controlId === dd.childControlId);
                    if (childObj.length > 0) {
                        const pData = stateData[dd.controlId];
                        if (pData) {
                            const pObj = dd?.allOptionData?.filter(x => x.name === pData);
                            if (pObj && pObj.length > 0) {
                                if (childObj.length > 0) {
                                    const childOptions = childObj[0].allOptionData?.filter(x => x.parentCode === pObj[0].code);
                                    childObj[0].optionData = childOptions;
                                }
                            }
                            else {
                                childObj[0].optionData = [];
                            }
                        }
                        else {
                            childObj[0].optionData = [];
                        }
                        const index = updResult.findIndex(x => x.controlId === dd.childControlId);
                        updResult[index] = childObj[0];
                    }

                }
            })
            setDdTypeCodMngr(updResult);
        }

        if (ddResult.subformDataType.length > 0) {
            // const result = await Promise.all(ddResult.subformDataType.map(async (sub) => {
            //     const subDdItems = await getSubformDatatypes(sub.dataType, sub.attribute);
            //     return subDdItems;
            // }));
            setSubformDataType(ddResult.subformDataType);
        }
    }

    useEffect(() => {
        if (summaryFormUpdateStatusSelector) {
            getAlert("", "Updated successfully", "success");
            dispatch(formUpdated(false));
            handleNextTask();
        }
    }, [summaryFormUpdateStatusSelector]);

    useEffect(() => {
        if (updatedStateData && updatedStateData !== "") {
            const obj = getApplicationData(updatedStateData);
            if (obj?.aWorkfinityApp)
                setAworkfinityApp(obj.aWorkfinityApp);

            if (obj?.aWorkfinityAppEntity)
                setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);
            if (obj?.data)
                setStateData(obj.data);
        }
        else {
            setStateData({});
        }
    }, [updatedStateData]);

    const loadStateCounty = async () => {
        const addResult = await getStateCountyCity(wfForm, stateData);
        const presult = await Promise.all(Object.keys(addResult).map(async (x) => {
            const obj = addResult[x];
            if (obj) {
                const nObj = await Promise.all(obj.stateObjects.map(async (s) => {
                    const nX = { ...s }
                    const rs = await geoService.getGeoData(s.id);
                    nX.list = rs;
                    return nX;
                }));

                obj.stateObjects = nObj;

                const cObj = await Promise.all(obj.countyObjects.map(async (s) => {
                    const stList = nObj.filter(x => x.childCompId === s.compId);
                    if (stList.length > 0) {
                        const stObj = stList[0].list.filter(x => x.name === s.name);
                        if (stObj.length > 0) {
                            const nX = { ...s }
                            const rs = await geoService.getGeoData(stObj[0].geonameId);
                            nX.list = rs;
                            nX.id = stObj[0].geonameId;
                            return nX;
                        }
                    }
                }));

                obj.countyObjects = cObj;

                const ccObj = await Promise.all(obj.cityObjects.map(async (s) => {
                    const ctList = cObj.filter(x => x.childCompId === s.compId);
                    if (ctList.length > 0) {
                        const stObj = ctList[0].list.filter(x => x.name === s.name);
                        if (stObj.length > 0) {
                            const nX = { ...s }
                            const rs = await geoService.getGeoData(stObj[0].geonameId);
                            nX.list = rs;
                            nX.id = stObj[0].geonameId;
                            return nX;
                        }
                    }
                }));

                obj.cityObjects = ccObj;
            }
            return obj;
        }));
        dispatch(allStateCountyCityReceived(presult));
    }

    const loadButtonProcessIds = async () => {
        const addResult = await getAllButtonProcessIds(wfForm);
        if (addResult.length) {
            dispatch(loadAllButtonAlertMessages(addResult));
        }
    }

    const handleSubformModalShowHide = (name) => {
        const newStateData = { ...stateData };
        const modelId = name.split("-");
        if (modelId.length > 1) {
            newStateData[modelId[0]] = !stateData[modelId[0]];
            setSubformItemIndex(parseInt(modelId[1]));
        }
        else {
            newStateData[name] = !stateData[name];
            setSubformItemIndex(-1);
        }
        setStateData(newStateData);
    }

    const handleSubformSave = (subFormObj, subFormDd, subFormAtt) => {
        const subformControlId = subFormDd.toLowerCase() + "." + subFormAtt;
        let subFormArray = [];
        if (stateData[subformControlId] && stateData[subformControlId].length > 0) {
            if (subformItemIndex > -1) {
                subFormArray = [...stateData[subformControlId]];
                subFormArray[subformItemIndex] = subFormObj;
                stateData[subformControlId][subformItemIndex] = subFormObj;
            }
            else {
                subFormArray = [...stateData[subformControlId], subFormObj];
                stateData[subformControlId] = [...stateData[subformControlId], subFormObj];
            }
        } else {
            subFormArray.push(subFormObj);
            stateData[subformControlId] = subFormArray;
        }
        setStateData(stateData);
        const newWfEntity = { ...aWorkfinityAppEntity };
        newWfEntity[subFormDd.toLowerCase()][subFormAtt] = subFormArray;
        setAworkfinityAppEntity(newWfEntity);
    };

    const handleEditSubForm = (subformDd, subformObj) => {
        // console.log(subformDd);
        // console.log(subformObj);
        // Object.keys(subformObj).map(val => {
        //     stateData[subformDd.toLowerCase() + "." + val.replace("@", "")] = subformObj[val];
        // });
    }

    useEffect(() => {
        if (subFormObj) {
            const newState = { ...stateData, ...subFormObj };
            setStateData(newState);
        }
    }, [subFormObj])

    const addEncryptionFieldData = (name, value) => {
        const encryp = { ...encryptionDecryptions };
        const data = { ...stateData }
        const newValue = value.replace(/\-/g, "");

        let modifiedValue = "";
        for (let i = 0; i < newValue.length; i++) {
            modifiedValue += "*";
        }
        if (encryp[name + "encrypt"]) {
            data[name] = modifiedValue;
            encryp[name] = encryp[name] + value.replace(/[^\d]/g, "");
        } else {
            data[name] = value.replace(/[^\d]/g, "");
            encryp[name] = modifiedValue;
        }
        setEncryptionDecryptions(encryp);
        setStateData(data);
    };

    const handleEncryptionDecryption = (name) => {
        const updatedData = { ...stateData };
        const encryp = { ...encryptionDecryptions };
        if (encryp[name + "encrypt"]) {
            const actualValue = encryp[name];
            const encryptedValue = updatedData[name];
            encryp[name] = encryptedValue;
            updatedData[name] = actualValue;
            encryp[name + "encrypt"] = false;
        } else {
            const encryptedValue = encryp[name];
            const actualValue = updatedData[name];
            encryp[name] = actualValue;
            updatedData[name] = encryptedValue;
            encryp[name + "encrypt"] = true;
        }
        setEncryptionDecryptions(encryp);
        setStateData(updatedData);
    };

    const handeOnChange = ({ target: input }) => {
        handleChange(input);
        if (input.dataset?.encryption) {
            addEncryptionFieldData(input.name, input.value);
        }
    };

    const handleChange = (input) => {
        const data = { ...stateData };
        const errors = { ...stateErrors };

        const errorMessage = validateProperty(input);
        if (errorMessage) {
            errors[input.name] = errorMessage;
        } else {
            delete errors[input.name];
        }

        data[input.name] = input.value;

        const finalRateStr = data["candidateonboardingform.Final_Rate_hour_Paid_to_Candidate"];
        const techFeeStr = data["candidateonboardingform.Candidate_Less_TechFee"];

        const finalRate = parseFloat(finalRateStr);
        const techFee = parseFloat(techFeeStr);

        if (!isNaN(finalRate)) {
            if (!isNaN(techFee)) {
                if (techFee <= finalRate) {
                    data["candidateonboardingform.Rate_hour_Paid_to_Candidate"] = parseFloat(finalRate - techFee).toFixed(2);
                } else {
                    errors["candidateonboardingform.Candidate_Less_TechFee"] = "Tech Fee cannot be greater than Final Rate";
                    data["candidateonboardingform.Rate_hour_Paid_to_Candidate"] = "";
                }
            } else {
                data["candidateonboardingform.Rate_hour_Paid_to_Candidate"] = finalRate
            }
        }

        setStateData(data);
        setStateErrors(errors);
        setCurrentInputField(input?.type);
    };

    const onFileChange = (event) => {
        const docs = [...documents];
        const data = { ...stateData };

        const docIndex = docs.findIndex((x) => x.refId === event.target.name);
        if (docIndex > -1) {
            docs.splice(docIndex, 1);
        }
        let indx = 0;
        if (docs.length > 0) {
            indx = docs[docs.length - 1].id;
        }
        for (const file of event.target.files) {
            indx += 1;
            const ext = file.name.split(".");
            var doc = {
                id: indx,
                name: file.name,
                newName: file.name,
                type: file.type,
                file: file,
                refId: event.target.name,
                extension: ext.length > 1 ? ext[1] : "",
                size: file.size
            };
            docs.push(doc);
        }

        data[event.target.id] = event.target.files[0].name;
        validateDocuments(docs);
        setDocuments(docs);
        setStateData(data);
    };

    const validateDocuments = (docs) => {
        const errors = { ...stateErrors };
        const data = { ...stateData };
        if (docs.length > 0) {
            data["docs"] = docs.length.toString();
            delete errors["docs"];
        } else {
            const obj = { schedule: "" };
            const schema = { schedule: stateSchema["docs"] };
            const { error } = Joi.validate(obj, schema);
            errors["docs"] = error.details[0].message;
            data["docs"] = "";
        }
        setStateData(data);
        setStateErrors(errors);
    };

    const validateProperty = ({ name, value }) => {
        if (stateSchema[name] != undefined) {
            const obj = { [name]: value };
            const schema = { [name]: stateSchema[name] };
            const { error } = Joi.validate(obj, schema);
            return error ? error.details[0].message : null;
        } else {
            return null;
        }
    };

    const validate = () => {
        if (wfTask?.status) return true;
        const options = { abortEarly: false, allowUnknown: true };
        const result = Joi.validate(stateData, stateSchema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) errors[item.path[0]] = item.message;
        return errors;
    };

    const doSubmit = (btn, alMsg) => {
        const btnType = btn.name;
        setCurrentButtonMessage(alMsg);
        setBtnProcessStatus(true);
        setCurrentButtonType(btnType);
        if (wfTaskType === "form" || wfTaskType === "subform") {
            setBtnProcessStatus(true);
            handleNextTask(stateData, btnType);
        }
        else {
            Object.keys(stateData).forEach(function (keyValue) {
                const dd = keyValue.split(".");
                if (dd.length > 1) {
                    if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                        if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                            var item = stateData[keyValue];
                            if (Array.isArray(item))
                                aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                            else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                        }
                }
            });

            const appShortName = Object.keys(aWorkfinityApp)[1];
            aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
            const frmData = new FormData();
            frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
            frmData.append("workItem", JSON.stringify(wfTask));
            frmData.append("upDocs", JSON.stringify(documents));
            // documents.map((file, key) =>
            //     frmData.append("files[" + key + "]", file.file)
            // );
            frmData.append("files", JSON.stringify(documents.map((file) => {
                return {
                    id: file.id,
                    name: file.name,
                    newName: file.newName,
                    type: file.type,
                    extension: file.extension,
                    refId: file.refId,
                    size: file.size
                }
            })));


            if (documentInfo) {
                frmData.append("docType", documentInfo.docType);
                frmData.append("updType", documentInfo.updType);
                frmData.append("message", documentInfo.message);
            }

            dispatch(saveBprmForm(frmData));

            if (wfTaskType === "viewForm") {
                setBtnProcessStatus(true);
                handleNextTask(frmData);
            }
            else if (btnType !== "save" && wfTask?.wiid > 0) {
                setBtnProcessStatus(true);
                setIsTaskForm(true);
            }
        }
    }

    useEffect(() => {
        if (taskFormSavedStatusSelector && isTaskForm) {
            dispatch(workflowTaskDone(wfTask));
            dispatch(taskFormSaved(false));
            setIsTaskForm(false);
        }
        else if (taskFormSavedStatusSelector) {
            setIsTaskForm(false);
            dispatch(taskFormSaved(false))
            setBtnProcessStatus(false);
        }
        if (currentButtonMessage !== "") {
            getAlert("", currentButtonMessage, "success");
            setCurrentButtonMessage("");
            setCurrentButtonType("");
        }
    }, [taskFormSavedStatusSelector]);

    useEffect(() => {
        if (taskDoneStatusSelector) {
            dispatch(taskDone({ status: false }))
            if (currentButtonMessage !== "") {
                getAlert("", currentButtonMessage, "success");
                setCurrentButtonMessage("");
                setCurrentButtonType("");
            }
            handleNextTask(currentButtonType);
        }
    }, [taskDoneStatusSelector])

    useEffect(() => {
        const uploadAllDocuments = async () => {
            if (savedFormDocSasUrlsSelector?.length > 0) {
                try {
                    await Promise.all(
                        documents.map((file, key) =>
                            uploadFileToBlob(
                                file.file,
                                savedFormDocSasUrlsSelector[key]?.uploadUrl,
                                (progress) => {
                                    console.log(`Upload progress: ${progress}%`);
                                }
                            )
                        )
                    );

                    // Runs only after ALL uploads finish   
                    console.log("All files uploaded successfully!");
                    dispatch(formSaved({ sasResp: null }));
                } catch (error) {
                    console.error("Upload failed:", error);
                }
            }
        };

        uploadAllDocuments();
    }, [savedFormDocSasUrlsSelector]);

    const updateBprmFormData = async () => {
        const disValus = _.uniq(frmDDTypes);
        Object.keys(stateData).forEach(function (keyValue) {
            const dd = keyValue.split(".");
            if (dd.length > 1) {
                if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                    if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                        var item = stateData[keyValue];
                        if (Array.isArray(item))
                            aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                        else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                    }
            }
        });
        const appShortName = Object.keys(aWorkfinityApp)[1];
        aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
        const currentUser = getCurrentUser();
        const frmData = new FormData();
        frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
        frmData.append("ciid", wfTask.ciid);
        frmData.append("ddTypes", disValus);
        frmData.append("formId", wfTask.formId);
        frmData.append("performerId", currentUser.id);
        frmData.append("userName", currentUser.name);
        dispatch(updateSummaryBprmForm(frmData));
    };

    const getEvaluatedValue = async (comp) => {
        const ruleId = comp.rule;
        const data = { ...stateData };
        Object.keys(data).forEach(function (keyValue) {
            const dd = keyValue.split(".");
            if (dd.length > 1) {
                if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                    if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                        var item = data[keyValue];
                        if (Array.isArray(item))
                            aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                        else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                    }
            }
        });
        const appShortName = Object.keys(aWorkfinityApp)[1];
        aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(aWorkfinityApp));
        formData.append("appId", 1);
        formData.append("ruleId", ruleId);
        dispatch(executeBprmFormRule(formData));
    };

    useEffect(() => {

        if (ruleAppDataSelector !== "") {
            const appShortName = Object.keys(ruleAppDataSelector)[1];
            const newAWorkfinityAppEntity = ruleAppDataSelector[appShortName];
            const data = { ...stateData };
            if (newAWorkfinityAppEntity !== "") {
                Object.keys(newAWorkfinityAppEntity).forEach(function (keyValue) {
                    if (
                        keyValue !== "@xmlns:xsd" &&
                        keyValue !== "@xmlns:xsi" &&
                        keyValue !== "EntityId"
                    ) {
                        Object.keys(newAWorkfinityAppEntity[keyValue]).forEach(function (
                            keyValue1
                        ) {
                            if (keyValue1 !== "EntityId") {
                                var item = newAWorkfinityAppEntity[keyValue][keyValue1];
                                if (typeof item === "object") {
                                    if (Array.isArray(item))
                                        data[keyValue + "." + keyValue1.replace("@", "")] = item;
                                    else data[keyValue + "." + keyValue1.replace("@", "")] = [item];
                                } else {
                                    data[keyValue + "." + keyValue1.replace("@", "")] = item;
                                }
                            }
                        });
                    }
                });
            }
            setStateData(data);
        }
    }, [ruleAppDataSelector])

    const getSubformTableHeader = (comp) => {
        const tdCss = {
            border: "1px solid #c1a0d9",
            fontWeight: "600", textTransform: "uppercase", fontSize: "0.875rem", color: "black"
        }

        if (comp.itemColumns?.length === 0)
            return <tr><th className="p-2" style={tdCss}>Datatype not found</th></tr>

        return <tr>
            {comp.itemColumns.filter(x => x.visible === false).map(item =>
                <th className="p-2" style={tdCss}>{item.name}</th>
            )}
            {comp.isEdit && <th className="p-2" style={tdCss}>Action</th>}
        </tr>

        // const tblHd = subformDataType?.filter(
        //     (x) =>
        //         x.dataType ===
        //         comp.attributeType &&
        //         x.attribute ===
        //         comp.attributeObject
        // );
        // if (tblHd.length === 0) return <tr>
        //     <th className="p-2" style={tdCss}>Datatype not found</th>
        // </tr>
        // return <tr>
        //     {tblHd[0].itemList?.map(item => <th className="p-2" style={tdCss}>
        //         {item.split(".")[1]}
        //     </th>)}
        //     {comp.isEdit && <th className="p-2" style={tdCss}>Action</th>}
        // </tr>
    }

    const getSubformTableBody = (comp) => {
        if (Object.keys(aWorkfinityAppEntity).length === 0) return;

        if (comp.itemColumns?.length === 0) return;

        const dataObj = aWorkfinityAppEntity[comp.attributeType?.toLowerCase()][comp.attributeObject];

        if (!dataObj) return;

        let dtObjArray = [];
        if (!isArray(dataObj))
            dtObjArray.push(dataObj);
        else
            dtObjArray = dataObj;

        if (dtObjArray?.length > 0) {
            return dtObjArray.map((obj, key) =>
                <tr>
                    {comp.itemColumns.filter(x => x.visible === false).map(item =>
                        <td className="p-2">
                            {item.ddType === "link" && CreateTableCellLink(item, obj, key)}
                            {item.ddType != "link" && obj["@" + item.type]}
                        </td>
                    )}
                    {comp.isEdit && <td className="p-2">
                        <button
                            className="btn btn-sm btn-outline-dark"
                        //onClick={() => handleSubformModalShowHide("showHide" + comp.subform + "-" + key)}
                        >
                            Edit
                        </button>
                    </td>}
                </tr>
            )
        }

        // const tblBd = subformDataType?.filter((x) => x.dataType === comp.attributeType && x.attribute === comp.attributeObject);

        // if (dtObjArray?.length > 0) {
        //     return dtObjArray.map((obj, key) =>
        //         <tr>
        //             {tblBd.length > 0 && tblBd[0].itemList.map(item => <td className="p-2">
        //                 {obj["@" + item.split(".")[0]]}
        //             </td>)}
        //             {comp.isEdit && <td className="p-2">
        //                 <button
        //                     className="btn btn-sm btn-outline-dark"
        //                     onClick={() => handleSubformModalShowHide("showHide" + comp.subform + "-" + key)}
        //                 >
        //                     Edit
        //                 </button>
        //             </td>}
        //         </tr>
        //     )
        // }

        return <tr><td>No Data</td></tr>
    }

    const CreateTableCellLink = (item, obj, key) => {
        let cellData = obj["@" + item.type];
        const cellSource = item.source.split("_");
        let linkUrl = "";
        let linkDdType = "";
        let linkAtt = "";

        if (cellSource.length > 0)
            linkUrl = cellSource[0];
        if (cellSource.length > 1)
            linkDdType = cellSource[1]
        if (cellSource.length > 2)
            linkAtt = cellSource[2];

        if (!cellData)
            cellData = item.name;

        let queryData = "";
        if (linkDdType === item.ObjectAttributeType) {
            queryData = obj["@" + linkAtt];
        }
        else if (linkDdType !== "" && linkAtt !== "") {
            queryData = stateData[linkDdType.toLocaleLowerCase() + "." + linkAtt];
        }
        else {
            queryData = cellData;
        }

        const data = { id: key, name: item.name, appId: wfTask.ciid, data: queryData };
        //return <a href={linkUrl} target="_blank">{cellData}</a>
        //return <button className="btn btn-sm btn-link" onClick={() => handleCellLinkClick(linkUrl)}>{cellData}</button>
        //return <Link to={{ pathname: '/' + linkUrl }} target="_blank">{cellData}</Link>
        return <Link to={`/${linkUrl}?linkData=${JSON.stringify(data)}`} target="_blank">{cellData}</Link>
    }

    const getHighestColNum = (elements) => {
        const col = elements.reduce(function (prev, current) {
            return prev.components.length > current.components.length
                ? prev
                : current;
        });
        return col.components.length;
    }

    const handlePrintPdf = async (event) => {
        setPrintBtnProccess(true);
        const logImg = getEmergencyFoundImg();
        const frmData = new FormData();
        let outHtml = printBody.current.outerHTML;
        outHtml = outHtml.replace(/<br\s*\/?>/g, "")
        outHtml = outHtml.replaceAll('<span hidden="">#imgClose1</span>', '</img>');
        outHtml = outHtml.replaceAll(
            '<span hidden="">#imgClose</span>',
            logImg.outerHTML + "</img>"
        );
        frmData.append("html", outHtml);
        dispatch(printTemplatePdf(frmData));
    };

    const getEmergencyFoundImg = () => {
        var c = document.createElement("canvas");
        // var img = document.getElementById("Img1");
        // c.height = img.naturalHeight;
        // c.width = img.naturalWidth;
        var ctx = c.getContext("2d");
        // ctx.drawImage(img, 0, 0);
        var base64String = c.toDataURL();
        let img2 = document.createElement("img");
        img2.height = "80";
        img2.width = "80";
        img2.src = base64String;
        return img2;
    };

    useEffect(() => {
        if (templatePdfSelector) {
            setPrintBtnProccess(false);
            dispatch(templatePdfReceived(null));
            const url = window.URL.createObjectURL(templatePdfSelector);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }, [templatePdfSelector]);

    const handleClose = () => {
        if (handleCloseButton)
            handleCloseButton();
    }

    const getDataWithTable = (col) => {
        const allCompts = col?.components.filter(x => !isArray(x));
        if (allCompts.length > 0) {
            const rowsCompts = allCompts.splice(allCompts.length / 2);
            const colCompts = allCompts.splice(allCompts.length - rowsCompts.length);
            return <table className="table table-bordered table-sm">
                <thead className="table-light">
                    <tr>
                        {colCompts.map(cItem =>
                            <th style={{ whiteSpace: "pre-wrap", letterSpacing: "0px", textTransform: "none" }}>{cItem.text}</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {rowsCompts.map(rItem =>
                            <td>
                                {rItem?.dataType === "link" ? <a target="_blank"
                                    href={`${rItem.url}?linkData=${stateData[rItem?.attributeType?.toLowerCase() + "." + rItem.attributeObject]}`}>
                                    {rItem.label}</a> : stateData[rItem?.attributeType?.toLowerCase() + "." + rItem.attributeObject]}
                            </td>
                        )}
                    </tr>
                </tbody>
            </table>
        }
    }


    const getSubformDataBoxLayout = (subformElement) => {

        if (Object.keys(aWorkfinityAppEntity).length === 0) return;

        const findAttObj = subformElement.filter(x => x.attributeObject !== undefined && x.attributeObject !== "");

        let dtObjArray = [];
        if (findAttObj.length > 0) {
            const dataObj = aWorkfinityAppEntity[findAttObj[0].attributeType?.toLowerCase()][findAttObj[0].attributeObject];
            if (dataObj && !isArray(dataObj))
                dtObjArray.push(dataObj);
            else if (dataObj)
                dtObjArray = dataObj;
        }

        const getGroupName = (col) => {
            return col.components.filter(x => x.groupName !== undefined).map((c) => {
                return c.groupName;
            });
        }

        const getColWidth = (w) => {
            switch (w) {
                case 1:
                    return "";
                case 2:
                    return "10%";
                case 3:
                    return "15%";
                case 4:
                    return "20%";
            }
        }

        const withDataComp = subformElement.filter(x => x.attributeObject !== undefined && x.attributeObject !== "");
        const withOutDataComp = subformElement.filter(x => x.attributeObject === undefined || x.attributeObject === "");

        const hanleSubformData = (input, key, ctId) => {
            const { currentTarget: { name, value } } = input;
            const subformControlId = findAttObj[0].attributeType.toLowerCase() + "." + findAttObj[0].attributeObject;
            let subFormArray = [];
            if (stateData[subformControlId] && stateData[subformControlId].length > 0) {
                if (key > -1) {
                    subFormArray = [...stateData[subformControlId]];
                    const subFormObj = { ...subFormArray[key], ["@" + ctId]: value };
                    subFormArray[key] = subFormObj;
                    stateData[subformControlId][key] = subFormObj;
                }
                else {
                    subFormArray = [...stateData[subformControlId], subFormObj];
                    stateData[subformControlId] = [...stateData[subformControlId], subFormObj];
                }
            } else {
                subFormArray.push(subFormObj);
                stateData[subformControlId] = subFormArray;
            }
            setStateData(stateData);
            const newWfEntity = { ...aWorkfinityAppEntity };
            newWfEntity[findAttObj[0].attributeType.toLowerCase()][findAttObj[0].attributeObject] = subFormArray;
            setAworkfinityAppEntity(newWfEntity);
        }

        const getLinkDocuments = (updId) => {
            const docs = documentsSelector.filter(x => x.uploadId === updId);
            if (docs.length > 0) {
                return <>
                    <br />
                    {docs.map((doc) =>
                        <button className="btn btn-sm btn-link p-0" onClick={() => handleDownloadFile(doc)}>{doc.docName}</button>
                    )}
                </>
            }
            return <></>
        }

        return <div className="col-md-12">
            {withOutDataComp.filter(x => !x?.colName).map((col) =>
                <div>
                    {col.components.map((c) => {
                        if (c.dataType === "label" && !c?.colName) {
                            return <Label comp={c} controleId={""} stateData={stateData} />
                        }
                    })}
                </div>
            )}
            <table className="table table-bordered table-sm">
                <thead className="table-light">
                    <tr>
                        {withDataComp.length > 0 ? withDataComp.filter(x => x?.colName).map(col =>
                            <th width={getColWidth(parseInt(col.width))}>{col.colName}</th>
                        ) : withOutDataComp.filter(x => x?.colName).map(col =>
                            <th width={getColWidth(parseInt(col.width))}>{col.colName}</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {dtObjArray && dtObjArray?.map((obj, key) =>
                        <tr>
                            {withDataComp.map(col =>
                                <td>
                                    {_.uniq(getGroupName(col)).map((g) => {
                                        const grpComps = col.components.filter(x => x.groupName === g);
                                        return <div>
                                            {
                                                grpComps.map((c) => {
                                                    let controleId = "";
                                                    if (c.attributeType)
                                                        controleId = c.attributeType?.toLowerCase();

                                                    if (c.attributeObject)
                                                        controleId += "." + c.attributeObject;

                                                    if (c.dataType === "label") {
                                                        if (c.attributeDataTypes?.type === "phone") {
                                                            return <span>{formatPhoneNumber(obj["@" + c.attributeObject])}</span>
                                                        } else {
                                                            return <span className={`mr-1 ${c.attributeDataTypes?.type}`}>
                                                                {c.attributeObject ? obj["@" + c.attributeObject] : ""}
                                                            </span>
                                                        }
                                                    }

                                                    if (c.dataType === "multiLineBox") {
                                                        return <textarea name={controleId} id={controleId} value={obj["@" + c.attributeObject]}
                                                            className="form-control"
                                                            onChange={(input) => hanleSubformData(input, key, c.attributeObject)}>
                                                        </textarea>
                                                    }

                                                    if (c.dataType === "dropDown") {
                                                        return <select className="form-control"
                                                            id={controleId}
                                                            name={controleId}
                                                            value={obj["@" + c.attributeObject]}
                                                            onChange={(input) => hanleSubformData(input, key, c.attributeObject)}>
                                                            <option value="">Select</option>

                                                            {c?.dropdownvalue?.map((dd) =>
                                                                <option value={dd.value}>{dd.name}</option>)}
                                                        </select>
                                                    }

                                                    if (c.dataType === "link" && c.attributeDataTypes?.type === "ddrms") {
                                                        return getLinkDocuments(parseInt(obj["@" + c.attributeObject]));
                                                        // return <p>
                                                        //     {obj["@" + c.attributeObject] ? c.label : <a
                                                        //         target="_blank"
                                                        //         id={controleId}
                                                        //         href={`${c.url + obj["@" + c.attributeObject]}`}
                                                        //         name={controleId}
                                                        //     >{obj["@" + c.attributeObject]}</a>}

                                                        // </p>
                                                    }

                                                })
                                            }
                                        </div>
                                    })}
                                </td>
                            )}
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    let elements = [];
    if (wfForm?.elementJson) {
        try {
            elements = JSON.parse(wfForm?.elementJson);

        } catch {
            elements = [];
        }
    }

    const handleDecryptShowHide = () => {
        setDecryptShowHide(!decryptShowHide);
    };

    const verifySecurityCode = (code) => {
        if (code !== "12345") {
            getAlert("Invalid Code", "", "error");
        } else {
            getAlert("Authentication Successful", "", "success");
            setCodeIsVerified(true);
            setDecryptShowHide(false);
        }
    };
    const compNum = elements.length > 0 && wfTaskType === "template" ? getHighestColNum(elements) : 0;
    return (
        <fieldset disabled={false}>
            {wfTaskType === "template" &&
                <>
                    <div id="printBody" ref={printBody}>

                        <table className="table table-bordered bg-white">
                            {elements.map((col) => (
                                <tr>
                                    {col.components.filter(x => x.dataType !== "button").map((comp) => {
                                        let controleId = "";
                                        if (comp.attributeType)
                                            controleId = comp.attributeType?.toLowerCase();

                                        if (comp.attributeObject)
                                            controleId += "." + comp.attributeObject;

                                        return (
                                            <td
                                                style={{ whiteSpace: "pre-wrap" }}
                                                colSpan={
                                                    col.components.length === 1
                                                        ? compNum
                                                        : compNum - col.components.length
                                                }
                                            >
                                                {comp.dataType === "label" &&
                                                    <Label comp={comp} controleId={controleId} stateData={stateData} />}
                                                {comp.dataType === "textBox" &&
                                                    <TextBox
                                                        comp={comp}
                                                        controleId={controleId}
                                                        stateData={stateData}
                                                        stateErrors={stateErrors}
                                                        stateSchema={stateSchema}
                                                        codeIsVerified={codeIsVerified}
                                                        isDisabled={isDisabled}
                                                        handleChange={handleChange}
                                                        handeOnChange={handeOnChange}
                                                        getEvaluatedValue={getEvaluatedValue}
                                                    />}
                                                {comp.dataType === "multiLineBox" && <Multiline
                                                    comp={comp}
                                                    controleId={controleId}
                                                    stateData={stateData}
                                                    stateErrors={stateErrors}
                                                    isDisabled={isDisabled}
                                                    encryptionDecryptions={encryptionDecryptions}
                                                    handeOnChange={handeOnChange}
                                                    getEvaluatedValue={getEvaluatedValue}
                                                    handleEncryptionDecryption={handleEncryptionDecryption}
                                                />
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </table>
                    </div>

                    {/* <div id="printBody" ref={printBody}>
                        <table class="table table-bordered bg-white">
                            <tr>
                                <td colspan="1" style={{whiteSpace:"pre-wrap"}}>
                                    <label class="text-center  backgroundBlue form-group">
                                        <div>Email Template </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="1" style={{whiteSpace:"pre-wrap"}}>
                                    <label class="text-undefined   form-group">
                                        <div>Hi, This is a test email to ensure everything is working correctly. </div>
                                    </label>
                                </td>
                            </tr>
                        </table>
                    </div> */}
                </>
            }
            {wfTaskType !== "template" &&
                <div className="row">
                    {!codeVerified && isEncryptedForm &&
                        <div className="col-md-12 form-group">
                            <button
                                className="btn btn-outline-default btn-sm btn-min-width"
                                onClick={handleDecryptShowHide}
                            >
                                Decrypt
                            </button>
                        </div>}
                    {getSubformDataBoxLayout(elements.filter(x => x.groupName === "SubFormTable"))}
                    {elements.filter(x => x.groupName !== "SubFormTable").map((col) => {
                        let showColData = true;
                        if (col.isVisible) {
                            showColData = false;
                            if (col?.visibleAttributeType && col?.visibleAttributeObject) {
                                const vDd = col?.visibleAttributeType.toLowerCase() + "." + col?.visibleAttributeObject;
                                const vRv = col.visibleRuleValue;
                                const vRd = stateData[vDd];
                                const matches = vRv?.split(',')
                                    .map(v => v.trim().toLowerCase())
                                    .includes(vRd?.trim().toLowerCase());
                                if (matches) showColData = true;
                            }
                        }

                        return showColData && <div className={`col-${col.width} ${col?.cssclass ? col.cssclass : ""}`}>
                            {col?.groupName === "table" && getDataWithTable(col)}
                            {col?.groupName !== "table" && col?.groupName !== "SubFormTable" && col.components.map((comp, key) => {
                                let controleId = "";
                                if (comp.attributeType)
                                    controleId = comp.attributeType?.toLowerCase();

                                if (comp.attributeObject)
                                    controleId += "." + comp.attributeObject;

                                //console.log(comp)

                                if (comp.isRequired && controleId !== "" && comp.dataType !== "esign") {
                                    if (comp.label)
                                        stateSchema[controleId] = Joi.string().required().label(comp.label);
                                    else
                                        stateSchema[controleId] = Joi.string().required().label("Field is required");
                                }

                                if (comp.attributeType && frmDDTypes.indexOf(comp.attributeType) === -1) {
                                    frmDDTypes.push(comp.attributeType);
                                }

                                if (comp.dataType === "list") {
                                    const formDD = subformDataType?.filter(
                                        (x) =>
                                            x.dataType ===
                                            comp.attributeType &&
                                            x.attribute ===
                                            comp.attributeObject
                                    );
                                    return (
                                        <React.Fragment>
                                            <SubForm
                                                showHide={stateData["showHide" + comp.subform]}
                                                handleModalShowHide={handleSubformModalShowHide}
                                                title={comp.label}
                                                subFormId={comp.subform}
                                                aWorkfinityAppEntity={aWorkfinityAppEntity}
                                                subFormDataType={comp.attributeType}
                                                subFormAttribute={comp.attributeObject}
                                                handleSubformSave={handleSubformSave}
                                                subformItemIndex={subformItemIndex}
                                                formDD={formDD}
                                                handleEditSubForm={handleEditSubForm}
                                                comp={comp}
                                            ></SubForm>
                                            <table
                                                className="border w-100 mt-2"
                                                id={`table-to-xls-${comp.subform}`}
                                            >
                                                <thead style={{ backgroundColor: "#d7e0f2", color: "black" }}>
                                                    {getSubformTableHeader(comp)}
                                                </thead>
                                                <tbody>
                                                    {getSubformTableBody(comp)}
                                                </tbody>
                                            </table>
                                        </React.Fragment>
                                    );
                                } else
                                    if (comp.dataType === "button") {
                                        if (comp.buttonType?.type === "editForm" || comp.buttonType?.type === "subform") {
                                            return <Button comp={comp}
                                                btnProcessStatus={btnProcessStatus}
                                                isDisabled={isDisabled}
                                                isEdit={wfForm?.isEdit}
                                                handleClose={handleClose}
                                                handleSubformModalShowHide={handleSubformModalShowHide}
                                            />
                                        }
                                    } else {
                                        if (comp.dataType === "label") {
                                            return <Label comp={comp} controleId={controleId} stateData={stateData} />
                                        }
                                        if (comp.dataType === "textBox") {
                                            return <TextBox
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                stateSchema={stateSchema}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                handleChange={handleChange}
                                                handeOnChange={handeOnChange}
                                                getEvaluatedValue={getEvaluatedValue}
                                            />
                                        }

                                        if (comp.dataType === "dropDown") {
                                            return <Dropdown
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                stateCountyCity={stateCountyCity}
                                                setStateCountyCity={setStateCountyCity}
                                                ddTypeCodMngr={ddTypeCodMngr}
                                                setDdTypeCodMngr={setDdTypeCodMngr}
                                                handleChange={handleChange}
                                                handeOnChange={handeOnChange}
                                                setIsCountryStateChanged={setIsCountryStateChanged}
                                            //allStateList={allStateList}
                                            //allCountryList={allCountryList}
                                            />
                                        }

                                        if (comp.dataType === "date") {
                                            return <Date
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                handleChange={handleChange}
                                            />
                                        }

                                        if (comp.dataType === "multiLineBox") {
                                            return <Multiline
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                encryptionDecryptions={encryptionDecryptions}
                                                handeOnChange={handeOnChange}
                                                getEvaluatedValue={getEvaluatedValue}
                                                handleEncryptionDecryption={handleEncryptionDecryption}
                                            />
                                        }

                                        if (comp.dataType === "radio") {
                                            return <Radio
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                handeOnChange={handeOnChange}
                                            />
                                        }

                                        if (comp.dataType === "checkBox") {
                                            return <CheckBox
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                handleChange={handleChange}
                                                ddTypeCodMngr={ddTypeCodMngr}
                                            />
                                        }

                                        if (comp.dataType === "file") {
                                            return <FileUpload
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                onFileChange={onFileChange}
                                            />
                                        }

                                        if (comp.dataType === "viewFile") {
                                            return <ViewFile controlId={controleId} comp={comp} />
                                        }
                                    }
                            })}
                        </div>
                    }

                    )}
                    {/* {viewType && */}
                    <div className="col-md-12">
                        <div className="row">
                            {(appSummary || (wfTask?.wfPhase === "Approved" && wfTask?.formId === config.formIds.candidate.ReportingForm && wfTask?.taskDoneStatus === 4)) &&
                                <div className="col-md-12 text-center mb-2">
                                    {/* <button
                                        className="btn btn-outline-default"
                                        disabled={viewType}
                                        onClick={() => updateBprmFormData()}
                                    >
                                        Update
                                    </button> */}
                                    <MUIButton
                                        variant="outline"
                                        color="inherit"
                                        size="small"
                                        onClick={() => updateBprmFormData()}
                                        disabled={viewType}
                                        startIcon={
                                            btnProcessStatus ? (
                                                <CircularProgress size={16} color="inherit" />
                                            ) : (
                                                <EditIcon />
                                            )
                                        }
                                        sx={{
                                            "&.Mui-disabled": {
                                                backgroundColor: "#9e9e9e",
                                                color: "#333333",
                                                opacity: 1,
                                            },
                                            mr: 1,
                                            mb: 1,
                                            textTransform: "none",
                                            border: "1px solid #172b4d",
                                            color: "black",
                                            "&:hover": {
                                                backgroundColor: "#172b4d",
                                                color: "white",
                                                borderColor: "#172b4d",
                                            },
                                        }}
                                    >
                                        Update
                                    </MUIButton>

                                </div>
                            }

                            {!appSummary &&
                                <div className="col-md-12 text-center mb-2">
                                    {elements.map((col) =>
                                        col.components.filter(x => x.dataType === "button").map((comp) => {
                                            if (comp.buttonType?.type !== "taskCompleted"
                                                && comp.buttonType?.type !== "submit"
                                                && comp.buttonType?.type !== "subform"
                                                && comp.buttonType?.type !== "saveAndContinue")
                                                return <Button comp={comp}
                                                    btnProcessStatus={btnProcessStatus}
                                                    //setBtnProcessStatus={setBtnProcessStatus}
                                                    isDisabled={isDisabled}
                                                    setIsDisabled={setIsDisabled}
                                                    validate={validate}
                                                    doSubmit={doSubmit}
                                                    isEdit={wfForm?.isEdit}
                                                    handleClose={handleClose}
                                                    currentButtonType={currentButtonType}
                                                />
                                        })
                                    )}
                                </div>
                            }
                        </div>
                        <div className="card shadow-none border">
                            <div className="d-flex flex-row justify-content-center card-header text-center bg-lighter p-2">

                                {actionType === "workflow" &&

                                    <h4 className="mb-0 text-dark">
                                        <i
                                            className="fa fa-arrow-right mr-2"
                                            aria-hidden="true"
                                        ></i>
                                        WORKFLOW ACTION &nbsp;&nbsp; </h4>}

                                {!appSummary &&
                                    <>
                                        {wfTask?.wfPhase === "Approved" && wfTask?.formId === config.formIds.candidate.ReportingForm && wfTask?.taskDoneStatus === 4 ? "" : elements.map((col) =>
                                            col.components.filter(x => x.dataType === "button").map((comp) => {
                                                if (comp.buttonType?.type === "taskCompleted" || comp.buttonType?.type === "submit" || comp.buttonType?.type === "saveAndContinue")
                                                    return <Button comp={comp}
                                                        btnProcessStatus={btnProcessStatus}
                                                        //setBtnProcessStatus={setBtnProcessStatus}
                                                        isDisabled={isDisabled}
                                                        setIsDisabled={setIsDisabled}
                                                        validate={validate}
                                                        doSubmit={doSubmit}
                                                        isEdit={wfForm?.isEdit}
                                                        handleClose={handleClose}
                                                        size="btn-sm"
                                                        currentButtonType={currentButtonType}
                                                    />
                                            })
                                        )}
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>}

            {wfTaskType === "template" && <div className="col-md-12 text-center">
                <button className="btn btn-outline-dark" disabled={printBtnProccess} onClick={handlePrintPdf}>
                    Print
                </button>
            </div>}

            <DecryptAppData
                decryptShowHide={decryptShowHide}
                handleDecryptShowHide={handleDecryptShowHide}
                verifySecurityCode={verifySecurityCode}
            ></DecryptAppData>
        </fieldset>
    )
}